import { Box, Flex } from '@chakra-ui/react';
import { Loader } from '@/design-system/loader';

export const Loading = () => {
  return (
    <Box flex="1" height="100%">
      <Flex alignItems="center" justifyContent="center" height="100%">
        <Loader />
      </Flex>
    </Box>
  );
};
